<template>
  <div class="conte">
    <div class="contes">
      <div class="conte_fl">
        <img
          src="https://6368-changan2020-qtz0s-1302496284.tcb.qcloud.la/images/3719.png"
          alt=""
        />
      </div>
      <div class="conte_cz">
        <span
          >操作日期：
          <el-date-picker
            class="tes"
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </span>
        <span
          >典当类型：
          <el-select class="tes" v-model="value3" clearable placeholder="请选择">
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
        <span
          >典当状态：
          <el-select class="tes" v-model="value" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
        <span
          >操作人员：
          <el-select class="tes" v-model="value2" clearable placeholder="请选择">
            <el-option
              v-for="item in opt"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
      </div>

      <el-button type="primary" plain class="con_btn" @click="serch">{{
        serchs
      }}</el-button>
    </div>

    <!-- 搜索内容 -->
    <div class="conf">
      <el-table
        :data="tableData"
        border
        max-height="850"
        :summary-method="getSummaries"
        show-summary
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据正在从火星赶来,请等待..."
      >
        <el-table-column fixed="left" label="操作" width="100">
          <template slot-scope="scope" v-if="scope.row.stas == '续当'">
            <el-button @click="UpdateClick(scope.row)" type="text" size="small"
              >生成凭证</el-button
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="stas"
          label="典当状态"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ticketnumber"
          label="票号"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="name" label="姓名" header-align="center" align="center">
        </el-table-column>
        <el-table-column
          prop="itemname"
          label="物品名称"
          width="180"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="重量/g"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.weight !== undefined ? scope.row.weight : "未接入" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xuday"
          label="操作日期/时间"
          width="130"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.time !== undefined
                ? scope.row.xuday + " " + scope.row.time
                : scope.row.xuday
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="overdate"
          label="开始日期"
          width="130"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="enddate"
          label="到期日期"
          width="130"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="dday" label="天数" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="pri" label="典当金额" header-align="center" align="center">
        </el-table-column>
        <el-table-column
          prop="ytdy"
          label="逾期天数"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="xupri"
          label="典当综合费"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column prop="lx" label="典当利息" header-align="center" align="center">
        </el-table-column>

        <!-- <el-table-column prop="pena" label="罚息" header-align="center" align="center">
        </el-table-column> -->
        <el-table-column
          prop="lastlx"
          label="（上期/逾期）典当利息"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.lastlx !== undefined ? scope.row.lastlx : "0" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="wechatexpend"
          label="提现手续费"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.wechatexpend !== undefined ? scope.row.wechatexpend : "0" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="yspri"
          label="应收金额"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="rece"
          label="实付金额"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="couqons"
          label="优惠券"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="couqonmoney"
          label="优惠金额"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="xuname"
          label="操作人"
          header-align="center"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹窗上传 -->
    <div>
      <el-dialog
        title="生成凭证"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
      >
        <div>
          <Voucher :UpdateData="UpdateData" v-if="dialogVisible" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Voucher from "./voucher/Voucher.vue";
export default {
  name: "flow",
  data() {
    return {
      options: [
        {
          value: "建当",
          label: "建当",
        },
        {
          value: "续当",
          label: "续当",
        },
        {
          value: "赎当",
          label: "赎当",
        },
        {
          value: "绝当",
          label: "绝当",
        },
        {
          value: "回收",
          label: "回收",
        },
        {
          value: "还本",
          label: "还本",
        },
        {
          value: "分期还款",
          label: "分期还款",
        },
      ],
      opt: [
        {
          value: "小程序",
          label: "小程序",
        },
        {
          value: "小程序逾期",
          label: "小程序逾期",
        },
        {
          value: "人工操作",
          label: "人工操作",
        },
        {
          value: "逾期人工操作",
          label: "逾期人工操作",
        },
        {
          value: "管理员",
          label: "管理员",
        },
      ],
      optionsType: [
        {
          value: "民品",
          label: "民品",
        },
        {
          value: "汽车",
          label: "汽车",
        },
        {
          value: "房产",
          label: "房产",
        },
      ],

      value: "", //典当状态
      value1: "", //操作日期
      value2: "", //操作人员
      value3: "", //典当类型

      serchs: "搜索",

      tableData: [], //搜索数据

      ACCESS_TOKEN: "",

      loading: false,

      dialogVisible: false, //弹窗开关

      UpdateData: {}, //弹窗数据
    };
  },
  components: {
    Voucher,
  },

  methods: {
    serch() {
      //如果日期不为空
      if (this.value1 !== "") {
        let startDate = this.value1[0];
        let endDate = this.value1[1];

        this.loading = true;
        let serchData = [];
        return this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("yxus_record").where({xuday:_.gte("${startDate}").and(_.lte("${endDate}"))}).limit(1000).get()`,
          })
          .then((rs) => {
            if (rs.data.errcode !== 0) {
              return this.$notify.error({
                title: "错误提示",
                message: "密钥过期啦，请刷新页面",
              });
            }

            let TotalNum = Math.ceil(rs.data.pager.Total / 1000);

            //如果数据大于1000时候，进行多次查找
            if (rs.data.pager.Total > 1000) {
              for (let i = 0; i < TotalNum; i++) {
                let num = i * 1000;

                this.axios
                  .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("yxus_record").where({xuday:_.gte("${this.value1[0]}").and(_.lte("${this.value1[1]}"))}).limit(1000).skip(${num}).get()`,
                  })
                  .then((res) => {
                    res.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    });

                    serchData.push(...res.data.data);
                  });
              }
            } else {
              //数据小于等于1000时
              //把数据转成json格式
              rs.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

              serchData.push(...rs.data.data);
            }
          })
          .then(() => {
            //典当类型条件筛选
            if (this.value3 !== "") {
              //如果选择了典当类型条件时
              if (this.value3 == "民品") {
                //典当类型选择民品时
                setTimeout(() => {
                  let mData = serchData.filter((item) => {
                    return (
                      item.itemname.substr(0, 2) !== "汽车" &&
                      item.itemname.substr(0, 2) !== "房产"
                    );
                  });
                  this.searchType(mData);
                }, 2500);

                //  console.log('筛选了的数据', mData)

                // setTimeout(()=>{
                //   console.log('筛选了的数据666',mData)
                // },10000)
              } else if (this.value3 == "汽车") {
                //典当类型选择汽车时
                setTimeout(() => {
                  let carData = serchData.filter((item) => {
                    return item.itemname.substr(0, 2) == "汽车";
                  });
                  this.searchType(carData);
                }, 2500);
              } else if (this.value3 == "房产") {
                //典当类型选择房产时
                setTimeout(() => {
                  let HouseData = serchData.filter((item) => {
                    return item.itemname.substr(0, 2) == "房产";
                  });
                  this.searchType(HouseData);
                }, 2500);

                //   this.$alert('房产功能还未开通哦', '温馨提示', {
                //   confirmButtonText: '确定',
                // });
              }
            } else {
              //如果没有选择典当类型时
              setTimeout(() => {
                this.searchType(serchData);
              }, 2500);
            }
          });
      }
      this.$message({
        message: "请先选择要查询的日期哦",
        type: "warning",
      });
    },
    //典当状态查询 方法
    searchType(data) {
      this.loading = false;
      // console.log(data)
      //如果选择了状态，则查找日期与状态相匹配的数据
      if (this.value !== "") {
        //当选择了状态时，查找对应状态的数据
        // this.tableData =  rs.data.data.filter(ele=>ele.stas === this.value)
        let onedata = data.filter((ele) => ele.stas === this.value);

        //如果查找出来的数据为空时，提示没查找到数据
        if (data.length == 0) {
          this.$alert("没有查询到当前状态的数据哦", "温馨提示", {
            confirmButtonText: "确定",
          });
        } else {
          //如果查找到的数据不为空，进行第三条件筛选

          //判断是否有选择操作人员
          if (this.value2 !== "") {
            //选择了状态，操作人有值时执行
            this.searchUser(onedata);
          } else {
            //如果没选择操作人员时
            this.tableData = data.filter((ele) => ele.stas === this.value);
          }
        }
      } else {
        //如果没有选择状态，则往下查找是否选择了操作人员相匹配的数据
        // this.tableData = rs.data.data;

        if (this.value2 !== "") {
          //如果选择的时间段里,典当状态为空,选择了操作人员时
          this.searchUser(data);
        } else {
          //如果在选择的时间段里,没有选择典当状态,也没有选择操作人员时
          this.tableData = data;
        }
      }
    },

    //查找操作人员方法
    searchUser(data) {
      if (this.value2 == "小程序") {
        this.tableData = data.filter(
          (els) =>
            els.xuname.substr(0, 4) == "当户在线" ||
            els.xuname.substr(0, 5) == "小程序在线"
        );
        if (this.tableData.length == 0) {
          this.$alert("没有查询到当户在线操作的数据哦", "温馨提示", {
            confirmButtonText: "确定",
          });
        }
      } else if (this.value2 == "小程序逾期") {
        this.tableData = data.filter(
          (elc) =>
            elc.xuname.substr(0, 4) == "当户逾期" ||
            elc.xuname.substr(0, 5) == "小程序逾期"
        );
        if (this.tableData.length == 0) {
          this.$alert("没有查询到当户逾期操作的数据哦", "温馨提示", {
            confirmButtonText: "确定",
          });
        }
      } else if (this.value2 == "人工操作") {
        this.tableData = data.filter(
          (ele) =>
            ele.xuname.substr(0, 2) !== "当户" &&
            ele.xuname.substr(0, 3) !== "管理员" &&
            ele.xuname.substr(0, 3) !== "小程序" &&
            ele.ytdy == 0
        );
        if (this.tableData.length == 0) {
          this.$alert("没有查询到线下人工操作的数据哦", "温馨提示", {
            confirmButtonText: "确定",
          });
        }
      } else if (this.value2 == "逾期人工操作") {
        this.tableData = data.filter(
          (eld) =>
            eld.xuname.substr(0, 2) !== "当户" &&
            eld.xuname.substr(0, 3) !== "管理员" &&
            eld.xuname.substr(0, 3) !== "小程序" &&
            eld.ytdy > 0
        );
        if (this.tableData.length == 0) {
          this.$alert("没有查询到线下人工逾期操作的数据哦", "温馨提示", {
            confirmButtonText: "确定",
          });
        }
      } else if (this.value2 == "管理员") {
        this.tableData = data.filter((elf) => elf.xuname == "管理员");
        if (this.tableData.length == 0) {
          this.$alert("没有查询到管理员操作的数据哦", "温馨提示", {
            confirmButtonText: "确定",
          });
        }
      }
    },

    //列表统计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index == 0) {
          sums[index] = "合计：";
          return;
        }

        if (index === 1) {
          sums[index] = "业务数量:" + data.length;
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          index !== 2 &&
          index !== 3 &&
          index !== 4 &&
          index !== 9 &&
          index !== 13 &&
          index !== 14
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.round((prev + curr) * 100) / 100;
              // return Math.floor(prev + curr);
            } else {
              return prev;
            }
          }, 0);
          if (index == 5) {
            sums[index] += "克";
            return;
          }
          sums[index] += "元";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    //上传凭证
    UpdateClick(event) {
      this.UpdateData = event;
      this.dialogVisible = !this.dialogVisible;
    },
    //关闭上传凭证弹窗
    handleClose() {
      this.dialogVisible = false;
    },
  },
  created() {
    //ACCESS_TOKEN
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },
  // mounted() {

  // },
};
</script>
<style scoped>
.contes {
  width: 100%;
  height: 210px;
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.inpus {
  width: 50%;
}
.conf {
  margin: 20px auto;
  width: 100%;
  background: white;
}
.con_btn {
  width: 110px;
  height: 100px;
}
.conte_cz {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: initial;
}
.conte_cz span {
  margin: 6px 0;
}
.tes {
  width: 60%;
}
.conte_fl {
  /* width: 50%; */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.conte_fl img {
  width: 90%;
}
</style>
